import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetTemperatureBreachesExpandedQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
}>;

export type GetTemperatureBreachesExpandedQuery = {
  __typename?: 'query_root';
  container_insights_temperature_breaches_expanded: Array<{
    __typename?: 'container_insights_temperature_breaches_expanded';
    breach_id?: any | null;
    breach_start_datetime?: any | null;
    breach_end_datetime?: any | null;
    breach_start_gps?: any | null;
    breach_end_gps?: any | null;
    max_deviation?: any | null;
    reefer?: {
      __typename?: 'container_insights_reefers_expanded';
      id?: string | null;
      refrigeration_unit_model?: string | null;
      manufacturer?: string | null;
    } | null;
  }>;
};

export const GetTemperatureBreachesExpandedDocument = gql`
  query GetTemperatureBreachesExpanded(
    $where: container_insights_temperature_breaches_expanded_bool_exp
  ) {
    container_insights_temperature_breaches_expanded(where: $where) {
      breach_id
      breach_start_datetime
      breach_end_datetime
      breach_start_gps
      breach_end_gps
      max_deviation
      reefer {
        id
        refrigeration_unit_model
        manufacturer
      }
    }
  }
`;

export function useGetTemperatureBreachesExpandedQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetTemperatureBreachesExpandedQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetTemperatureBreachesExpandedQuery,
    GetTemperatureBreachesExpandedQueryVariables
  >({ query: GetTemperatureBreachesExpandedDocument, ...options });
}
